<script>
    import { IDLE, INCALL, OUTCALL } from 'common/callState';
    import DialNumber from './DialNumber.svelte';

    let dialNumber = '';
    let session = {
        callSession: null,
        peer: '',
        state: IDLE,
        ua: null,
        duration: 0,
        notes: '',
    };

    let mobile, sip_connected;

    let call_active = false;
    let take_note = false;
    let incoming_call_active = false;

    const ring = new Audio('https://outlinks.pressone.co/p0p');
    
    const setDuration = (duration) => {
        session = {
            ...session,
            duration,
        };
    };


    $: {
        if (session.state === INCALL || session.state === OUTCALL) {
            incoming_call_active = false;
            call_active = true;
        }
    }

    let remoteAudio;

    const answer = () => {
        const options = {
            mediaConstraints: { audio: true, video: false },
            pcConfig: {
                rtcpMuxPolicy: 'negotiate',
                iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
            },
        };
        session.callSession.answer(options);
        session = {
            ...session,
            state: INCALL,
        };
    };

    $: {
        if (
            session.state === INCALL ||
            session.state === OUTCALL ||
            session.state === IDLE
        ) {
            if (!ring.paused) {
                ring.pause();
                ring.currentTime = 0;
            }
        }
    }

</script>

<div id="user-settings-tabs">
    <div class="tabs">
        <DialNumber
            input={dialNumber}
            bind:remoteAudio
            {answer}
            {call_active}
            {incoming_call_active}
            {mobile}
            {ring}
            bind:session={session}
            {sip_connected}
            {take_note}
            {setDuration}
        />
    </div>
</div>

<style lang="scss">
    #user-settings-tabs {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
        .tabs {
            height: 100%;
        }
    }
    .menu {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
</style>